import { Grid, Typography } from "@mui/material";
import UserItemsTable, {
  Item,
} from "../../modules/users/components/UserItemsTable";
import BaseButton from "./BaseButton";
import AddIcon from "@mui/icons-material/Add";
import { CSSProperties } from "react";

export function ItemsDetails(props: {
  items: Item[];
  label?: string;
  itemLabel: string;
  onAdd: () => void;
  hover?: boolean;
  onRemove: (item: Item) => void;
  onAddWhatsApp?: (item: Item) => void;
  onRemoveWhatsApp?: (item: Item) => void;
  style?: CSSProperties;
  removeActions?: boolean;
  disableWhatsAppButton?: boolean;
}) {
  const {
    items,
    label,
    onAdd,
    onRemove,
    itemLabel,
    hover,
    style,
    removeActions,
    onAddWhatsApp,
    onRemoveWhatsApp,
    disableWhatsAppButton,
  } = props;

  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
        columnGap: "10px",
      }}
    >
      <Grid
        sx={{
          display: "flex",
          flexDirection: "row",
          columnGap: "10px",
          // alignItems: "center",
          width: "100%",
          // justifyContent: "space-between",
          justifyContent: { xs: "center", md: "space-between" },
          marginTop: "8px",
          marginBottom: "15px",
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "17px" },
            marginTop: { xs: "-5px", md: "5px" },
            // marginTop: "5px",
            height: "34px",
          }}
        >
          {label}
        </Typography>
        {!removeActions && (
          <BaseButton
            width={120}
            startIcon={<AddIcon />}
            title="Adicionar"
            onClick={onAdd}
            heigth={34}
            iconSize={"15px"}
            fontSize={"15px"}
          />
        )}
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          rowGap: "20px",
          // padding: "20px",
          width: "100%",
          height: "100%",

          // marginBottom: "30px",
        }}
      >
        <Grid item xs={12} sx={{ alignItems: "flex-start" }}>
          <UserItemsTable
            removeActions={removeActions}
            hover={hover}
            onRemove={onRemove}
            onAddWhatsApp={onAddWhatsApp}
            onRemoveWhatsApp={onRemoveWhatsApp}
            userItems={items}
            style={style}
            itemLabel={itemLabel}
            disableWhatsAppButton={disableWhatsAppButton}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
